import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import styles from '../../component/addCategoryForm/addCategoryForm.module.css';
import { Add, closeCircle, Delete, UploadImg, AddCircle } from '../../Svg';
import styless from '../../component/scheduleComps/scheduleList/partList.module.css';
import NestedUserHeader from "../../component/reusable/NestedUserHeader";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
import { toast } from "react-toastify";
import Slider from "./Slider";
import PopularProd from "./product/PopularProd";
import Categories from "./Categories";
import axios from "axios";
import { getHeroBannerThunk, heroBannerThunk, getLoginBuilderThunk } from "../../redux/appearanceSlice";
import { getCategoryHeirarchy } from "../../redux/getCategoryHeirarchy";
import FeaturedBrand from "./FeaturedBrand";
import { useNavigate } from "react-router-dom";


const Accordions = styled(Accordion)(({ theme }) => ({
  borderRadius: '8px !important',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  margin: "20px 0px",
  fontFamily: `'Public Sans', sans-serif`,
  '&::before': {
    background: 'transparent',
    content: 'none',
  },
}));

const defaultLoginSlides = [
  { image: '/assets/login.png', title: 'Thomas Edison', description: 'From pioneering electric light to shaping the future of innovation.' },
  { image: '/assets/login-slide-components.png', title: 'Built for precision', description: 'Source the right electronic components with clarity and confidence.' },
  { image: '/assets/login-slide-precision.png', title: 'Ideas into production', description: 'Bring every design to life with reliable sourcing in one place.' },
];

const getLoginSlides = (loginBanner) => {
  const savedSlides = loginBanner?.slides?.filter((slide) => slide?.image);

  if (savedSlides?.length) {
    const preparedSlides = savedSlides.slice(0, 3).map((slide, index) => ({ ...defaultLoginSlides[index], ...slide }));
    return [...preparedSlides, ...defaultLoginSlides.slice(preparedSlides.length)];
  }

  return [
    { ...defaultLoginSlides[0], image: loginBanner?.image || defaultLoginSlides[0].image },
    ...defaultLoginSlides.slice(1),
  ];
};


const HomePage = () => {
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const [loading, setLoading] = useState('')
  const bannerImageRef = useRef(null);
  const { heroBannerData, login } = useSelector((state) => state.appearances)
  const loginSlides = getLoginSlides(login?.data);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const isImage = (url) => /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
  const isVideo = (url) => /\.(mp4|mov|avi|webm)$/i.test(url);

  // General Information Formik
  const heroBannerFormic = useFormik({
    initialValues: {
      bannerTitle: heroBannerData?.data?.bannerTitle || '',
      bannerImage: heroBannerData?.data?.assets?.url || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      bannerTitle: Yup.string().required('bannerTitle is required'),
      bannerImage: Yup.string().required('bannerImage is required'),

    }),
    onSubmit: async (values) => {
      const data = {
        bannerTitle: values.bannerTitle,
        assets: {
          url: values.bannerImage,
          type: isImage(values.bannerImage) ? "IMAGE" : "VIDEO"
        },
        searchBar: true
      }
      // console.log(data);
      dispatch(heroBannerThunk(data));
    },
  });

  const handleImageChange = async (e, attribute, repo) => {

    const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
    setLoading('banner')
    try {
      if (file) {

        const body = {
          key: `${Date.now()}_${file.name}`,
          fileType: file.type,
          fileName: file.name,
        };

        const { data, status } = await api.getPutSignedUrl(body);
        console.log(data);

        if (status === 200) {
          await axios.put(data.data?.preSigned, file, {
            headers: {
              "Content-Type": file.type
            }
          })

          heroBannerFormic.setFieldValue(attribute, data?.data?.url)
        }
      }
    } catch (err) {
      console.log(err);
      toast.error("Error uploading file")
    } finally {
      setLoading('')
    }
  };

  const handleRemove = (repo) => {
    heroBannerFormic.setFieldValue(repo, '');
  };

  useEffect(() => {
    dispatch(getHeroBannerThunk())
    dispatch(getLoginBuilderThunk())
    dispatch(getCategoryHeirarchy());
  }, [dispatch])


  return (
    <>

      <NestedUserHeader
        index="Home Page Builder"
        root="Dashboard"
        buttonText={'Back to list'} />
      <Box sx={{ width: '85%', }}>
        {/* Hero Banner Section */}
        <Accordions sx={{ marginBottom: "20px" }}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{
              fontSize: "16px",
              color: "#1D1F2C",
            }}>Hero Banner</Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ background: '#F0F1F3B2', margin: "0px 20px 20px 20px" }}>
            <form onSubmit={heroBannerFormic.handleSubmit}>
              <label className={styles.addCatLabel} >
                Banner Title
                <input
                  type="text"
                  name="bannerTitle"
                  placeholder="Enter "
                  className={styles.addCatInput}
                  onChange={heroBannerFormic.handleChange}
                  onBlur={heroBannerFormic.handleBlur}
                  value={heroBannerFormic.values.bannerTitle}
                />
                {heroBannerFormic.touched.bannerTitle && heroBannerFormic.errors.bannerTitle && (
                  <div className={styles.errorText}>{heroBannerFormic.errors.bannerTitle}</div>
                )}
              </label>



              <div className={styles.imageUpload}>

                <p className={styles.addCatLabel}>Banner Image</p>
                {loading === 'banner' ? <div className={styles.uploadBox} style={{ background: '#fff', display: 'flex', justifyContent: 'center' }}>
                  please wait...
                </div> :
                  <>
                    {
                      heroBannerFormic.values.bannerImage
                        ?
                        <div className={styles.uploadBox} style={{ background: '#fff', display: 'flex', justifyContent: 'center' }}>
                          {isImage(heroBannerFormic.values.bannerImage) &&
                            <img src={heroBannerFormic.values.bannerImage} alt="" className={styles.previewImage} style={{ width: '100%', objectFit: 'contain' }} />
                          }
                          {isVideo(heroBannerFormic.values.bannerImage) &&
                            <video
                              controls
                              style={{ width: '100%', maxHeight: '500px' }}
                              className={styles.previewImage}
                            >
                              <source src={heroBannerFormic.values.bannerImage} type="video/mp4" />
                            </video>
                          }
                          <div className={styles.cancel_cross} onClick={() => handleRemove("bannerImage")}>
                            {closeCircle()}
                          </div>
                        </div>
                        :
                        <div
                          className={styles.uploadBox}
                          style={{ background: '#fff', cursor: 'pointer' }}
                          onClick={() => bannerImageRef.current.click()}
                          onDrop={(e) => {
                            e.preventDefault();
                            handleImageChange(e, 'bannerImage', 'bannerImage');
                          }}
                          onDragOver={(e) => e.preventDefault()}

                        >
                          <span className={styles.uploadIcon}><UploadImg /></span>
                          <p className={styles.addCatPara}>Drag and drop image here, or click add image</p>

                          <button type="button" className={styles.addImgBtn} >Add Image/video</button>
                          <input
                            type="file"
                            name=""
                            id=""
                            ref={bannerImageRef}
                            style={{ display: 'none' }}
                            onChange={(e) => handleImageChange(e, 'bannerImage', 'bannerImage')}
                            accept="image/*,video/*"
                          />
                        </div>
                    }
                  </>
                }
                {heroBannerFormic.touched.bannerImage && heroBannerFormic.errors.bannerImage && (
                  <div className={styles.errorText}>{heroBannerFormic.errors.bannerImage}</div>
                )}
                <div style={{ margin: "10px 0px 10px 0px", display: 'flex', justifyContent: 'flex-end', gap: '20px' }}>
                  <button className={styless.cancelBtn} onClick={() => heroBannerFormic.resetForm()}>Cancel</button>
                  <button className={styless.submitBtn} type="submit" >{heroBannerFormic.isSubmitting ? 'please wait...' : 'Save changes'}</button>
                </div>

              </div>


            </form>
          </AccordionDetails>
        </Accordions>

        <Accordions
          sx={{
            marginBottom: "20px",
            backgroundColor: '#FFFFFF',
            '&.Mui-expanded': { backgroundColor: '#FFFFFF' },
            '& .MuiAccordionSummary-root': { minHeight: 72 },
            '& .MuiAccordionSummary-root.Mui-expanded': { minHeight: 72 },
          }}
          expanded={expanded === "loginSlider"}
          onChange={handleChange("loginSlider")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box>
              <Typography sx={{ fontSize: "16px", color: "#1D1F2C", fontWeight: 700 }}>Login Slider</Typography>
              <Typography sx={{ fontSize: "13px", color: "#667085", mt: 0.35 }}>All login backgrounds, titles and descriptions.</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ background: '#F0F1F3B2', margin: "0px 20px 20px", padding: 2.5 }}>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' }, gap: 2 }}>
              {loginSlides.map((slide, index) => (
                <Box key={`${slide.image}-${index}`} sx={{ overflow: 'hidden', border: '1px solid #E5E7EB', borderRadius: 2, background: '#fff' }}>
                  <Box component="img" src={slide.image} alt={slide.title} sx={{ width: '100%', height: 150, display: 'block', objectFit: 'cover' }} />
                  <Box sx={{ p: 2 }}>
                    <Typography sx={{ color: '#5B21B6', fontWeight: 700, fontSize: '16px' }}>{slide.title}</Typography>
                    <Typography sx={{ color: '#667085', fontSize: '13px', lineHeight: 1.55, mt: 0.75 }}>{slide.description}</Typography>
                  </Box>
                </Box>
              ))}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button variant="contained" onClick={() => navigate('/appearance/loginPage')} sx={{ textTransform: 'none', background: '#5B2DBD' }}>
                Edit login slider
              </Button>
            </Box>
          </AccordionDetails>
        </Accordions>

        {/* Sliders Section */}
        <Slider
          Accordions={Accordions}
          handleChange={handleChange}
          expanded={expanded}
          isImage={isImage}
          isVideo={isVideo}
        />


        {/* Categories Section */}
        <Categories
          Accordions={Accordions}
          handleChange={handleChange}
          expanded={expanded}
        />

        <FeaturedBrand
          Accordions={Accordions}
          handleChange={handleChange}
          expanded={expanded}
        />



        {/* Product/Manufacturer */}
        <PopularProd
          Accordions={Accordions}
          handleChange={handleChange}
          expanded={expanded}
        />


      </Box>
    </>
  );
};

export default HomePage;
